<template>
	<div class="comp">
		<div class="showGoodsImg" v-if="videoState" style="z-index: 21;">
			<img src="../../../assets/img/cha.png" style="position: absolute;top:10px;right:10px;width:20px;height: 20px;cursor: pointer;z-index: 22;" @click="videoState=false;"/>
			<video style="width:100%;height: 100%;" :src="petDetail.bannerVideo.url" controls autoplay></video>    <!-- 视频 -->
		</div>
		<div class="showGoodsImg" ref="fdj" v-else>
			<img v-if="!$public.isNull(petDetail.bannerVideo)" src="../../../assets/img/goods/videoStart.png" class="videoBtn" @click="videoStart"/>   <!-- 视频开关 -->
			
			
			<img class="img1" :src="curImg">
			<div class="moveBox" v-bind:style="{ left: moveBox[0]+'px',top:moveBox[1]+'px'}" v-show="bigImgState"></div>
			<div class="bigImg" ref="bigImg" v-show="bigImgState">
				<img class="img2" :src="curImg" v-bind:style="{ marginLeft: bigImgMargin[0] + 'px',marginTop:bigImgMargin[1] + 'px'}">
			</div>
		</div>
		<div class="imgList">
			<div class="btnL" @click="clickL">
				<img src="../../../assets/img/goods/leftIcon.png"/>
			</div>
			<div class="btnImg">
				<div class="scrollBox" :style="{'left':marginLeft+'px'}">
					<img class="imgItem" :src="item.url" v-for="(item,index) in imgList" :key="index" @mouseenter="curImg=item.url" :class="curImg===item.url?'active':''"/>
				</div>
			</div>
			<div class="btnR" @click="clickR">
				<img src="../../../assets/img/goods/rightIcon.png"/>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				moveBox: [0, 0],
				bigImgMargin: [0, 0],
				bigImgState: false,
				curImg: "https://www.huashengchongwu.com/static/img/logo.png",
				
				imgList:[
					{
						url:'https://www.huashengchongwu.com/static/img/logo.png'
					},
				],
				marginLeft:0,
				
				videoState:false,
			}
		},
		props:{
			petDetail:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			if(!this.$public.isNull(this.petDetail.bannerList)){
				this.imgList = this.petDetail.bannerList
				this.curImg = this.imgList[0].url
			}
			// if(!this.$public.isNull(this.petDetail.bannerVideo)){
			// 	this.imgList.unshift(this.petDetail.bannerVideo)
			// 	this.curImg = this.imgList[0].url
			// }
			
			let that = this;
			this.$refs.bigImg.addEventListener("mouseenter", function() {
				that.bigImgState = false;
			});
			this.$refs.fdj.addEventListener("mouseover", function() {
				that.bigImgState = true;
			});
			this.$refs.fdj.addEventListener("mouseout", function(e) {
				that.bigImgState = false;
			});
			this.$refs.fdj.addEventListener("mousemove", function(e) {
				let curX = e.pageX - this.offsetLeft;
				let curY = e.pageY - this.offsetTop - 164;
				let cx, cy;
				if (curX < 100) {
					cx = 0;
				} else if (curX > 340) {
					cx = 240;
				} else {
					cx = curX - 100;
				}
				if (curY < 100) {
					cy = 0;
				} else if (curY > 340) {
					cy = 240;
				} else {
					cy = curY - 100;
				}
				that.moveBox = [cx, cy];
				that.bigImgMargin = [-3.3 * cx, -3.3 * cy];
				e.stopPropagation();
			},false);
		},
		methods:{
			videoStart(){
				this.videoState = true
				console.log(111)
			},
			clickL(){
				this.marginLeft = 0;
			},
			clickR(){
				this.marginLeft = -(this.imgList.length*100-340);
			},
		},
	}
</script>

<style lang="scss" scoped>
.comp{
	width:440px;
	.showGoodsImg{
		width:440px;height: 440px;border: 1px solid #ccc;position: relative;display: inline-block;
		.videoBtn{
			position: absolute;top:190px;left:190px;z-index: 20;width:60px;height: 60px;cursor: pointer;
		}
		.img1{
			width:100%;height: 100%;
		}
		.moveBox{
			width:200px;height: 200px;background-color: black;opacity: 0.5;position: absolute;cursor: move;
		}
		.bigImg{
			width:660px;height: 660px;overflow: hidden;position: absolute;left: 442px;top:0;background-color: #fff;
			.img2{
				width:1452px;height: 1452px;
			}
		}
	}
	.imgList{
		width:100%;display: flex;padding-top:20px;
		.btnL{
			width:40px;background-color: rgba(0, 0, 0, 0.06);height: 92px;margin-right: 10px;cursor: pointer;text-align: center;line-height: 100px;
		}
		.btnImg{
			overflow:hidden;height: 92px;white-space: nowrap;width:340px;font-size: 0;position: relative;
			.scrollBox{
				width:100%;height: 100%;position: absolute;transition:left .5s;left:0;
				.imgItem{
					width:90px;height: 90px;margin-right: 10px;border:1px solid transparent;
					&.active{
						border-color:#FF8400;
					}
				}
			}
			
		}
		.btnR{
			width:40px;background-color: rgba(0, 0, 0, 0.06);height: 92px;margin-left: 10px;cursor: pointer;text-align: center;line-height: 100px;
		}
	}
}
</style>							
